module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "toc-title"
  }, [_vm._v("TABLE OF CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm04"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("FOREWORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm05"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chap01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 1:")]), _vm._v(" INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 2:")]), _vm._v(" COACHING WINNING RUNNERS")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("How to Run Fast")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 3:")]), _vm._v(" A CHAMPIONSHIP SEASON")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("One Workout at a Time")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#bx1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CASE STUDY: HALEY HERBERG"), _c('br'), _vm._v("The Making of a State Champion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 4:")]), _vm._v(" RACING")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("How to Win with Techniques, Strategies, and Tactics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 5:")]), _vm._v(" THE MENTAL RACE")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("How to Have Confidence on Race Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05#bx2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CASE STUDY: ASHLEY LICATA"), _c('br'), _vm._v("Overcoming Race Day Nerves to Become a Champion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 6:")]), _vm._v(" PREPARING AND REPAIRING")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fuel, Fluids, and Injuries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#bx3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CASE STUDY: ALYSSA BAUTISTA"), _c('br'), _vm._v("Swimming to UCLA Through Iron-Deficient Waters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#bx4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CASE STUDY: BRONTE GOLICK"), _c('br'), _vm._v("From Martial Arts to Bronte Shirts to Top UCLA Runner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 7:")]), _vm._v(" TRICKS OF THE TRADE")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Breathing, Form, and Hills")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 8:")]), _vm._v(" A CHAMPIONSHIP MINDSET")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deciding to Be the Best")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 9:")]), _vm._v(" STARTING A HIGH SCHOOL PROGRAM")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who are the Runners?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 10:")]), _vm._v(" BOOSTER CLUB AND PARENT INVOLVEMENT")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Your Program Support System")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 11:")]), _vm._v(" SCHOOL ADMINISTRATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 12:")]), _vm._v(" CAPTAIN-AND ATHLETE-LED PRACTICES")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leadership in Action")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 13:")]), _vm._v(" SETTING UP THE SUMMER PROGRAM")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Organizing for Winning")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13#bx5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CASE STUDY: CARLY CORSINITA"), _c('br'), _vm._v("From Humble Beginnings to the Oregon Ducks . . . Because She Wanted It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap13#bx6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CASE STUDY: JVS AND OTHER NON-VARSITY RUNNERS - Unsung Heroes, Future Stars, and Lifelong Runners")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 14:")]), _vm._v(" SELECT SUMMER TRAINING CAMPS")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mammoth Camp")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 15:")]), _vm._v(" THE PROMISED LAND")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Post-Season Championship Racing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 16:")]), _vm._v(" AWARDS AND REWARDS")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Recognition of a Job Well Done")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 17:")]), _vm._v(" THE BANQUET")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Celebrating the Season")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 18:")]), _vm._v(" POST SEASON AND TRANSITION TO TRACK AND FIELD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 19:")]), _vm._v(" DISTANCE TEAM AT TRACK AND FIELD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap19#bx7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CASE STUDY: NATALIE HERBERG"), _c('br'), _vm._v("Speed to Burn!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 20:")]), _vm._v(" DESIGNING COURSES AND MANAGING RACES")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("How to Organize Chaos")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("CHAPTER 21:")]), _vm._v(" VIRTUAL COACHING")]), _c('br'), _c('em', {
    staticClass: "italic"
  }, [_vm._v("When You Can’t Be There in Person")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocft"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RESOURCES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("APPENDIX 1")]), _vm._v(" CAPO VALLEY LADY COUGAR CROSS COUNTRY TRAINING SYSTEM")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("APPENDIX 2")]), _vm._v(" SAMPLE LADDER CHART")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("APPENDIX 3")]), _vm._v(" CVHS CROSS COUNTRY"), _c('br'), _vm._v("Practice Etiquette and Safety Prepared by CVHS Boys’ Coach Matt Soto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("APPENDIX 4")]), _vm._v(" RACE DAY SCHEDULE FOR DANA INVITATIONAL"), _c('br'), _vm._v("Saturday, Sep 22, 2018")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("APPENDIX 5")]), _vm._v(" SAMPLE RACE SPLIT SHEET"), _c('br'), _vm._v("visit www.coachrunwin.com for a downloadable version")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("APPENDIX 6")]), _vm._v(" GOAL SHEET")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("APPENDIX 7")]), _vm._v(" A SAMPLE WEIGHT WORKOUT FOR INDIVIDUAL RUNNERS"), _c('br'), _vm._v("(By One of Our Athletes)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("APPENDIX 8")]), _vm._v(" LADY COUGAR CROSS COUNTRY"), _c('br'), _vm._v("Course Requirements and Grading System")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("APPENDIX 9")]), _vm._v(" LADY COUGAR CROSS COUNTRY LETTERING POLICY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tno"
  }, [_vm._v("TABLE 1")]), _vm._v(" Training Paces Based on VDOTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocft"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ABOUT THE AUTHOR")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0